import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: () => import('./views/home.vue')
    },
    {
      path: '/monsters/:id',
      component: () => import('./views/monster.vue')
    },
    {
      path: '/items/:id',
      component: () => import('./views/item.vue')
    },
    {
      path: '/spells/:id',
      component: () => import('./views/spell.vue')
    },
    {
      path: '/players/:id',
      component: () => import('./views/player.vue')
    }
  ]
})
